import { useState } from 'react';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import type { ShippingPromotion } from '../../lib/api/operatorConsole';
import { backendMessage } from '../TestPlayers/backendMessage';

interface Props {
  promotion: ShippingPromotion;
  /** Rejects with the backend's error, which the dialog shows and stays open on. */
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

export function DisablePromotionDialog({ promotion, onConfirm, onClose }: Props) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleConfirm() {
    setError(null);
    setBusy(true);
    try {
      await onConfirm();
    } catch (err) {
      setError(backendMessage(err) ?? 'Could not disable this promotion.');
      setBusy(false);
    }
  }

  return (
    <Modal
      open
      title="Disable promotion"
      onClose={onClose}
      footer={
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button type="button" onClick={() => void handleConfirm()} disabled={busy}>
            {busy ? 'Disabling…' : 'Disable promotion'}
          </Button>
        </div>
      }
    >
      <p className="text-[13px] text-[var(--co-text)]">
        Disable <strong>{promotion.label}</strong>? Deliveries created from now on are priced at the
        regular shipping and handling fees. Deliveries already created keep the price their players
        paid.
      </p>
      <p className="mt-2 text-[13px] text-[var(--co-muted)]">
        This cannot be undone. To run the promotion again, create a new one.
      </p>
      {error && (
        <p role="alert" className="mt-3 text-[12px] text-[var(--co-error)]">
          {error}
        </p>
      )}
    </Modal>
  );
}
